import React from 'react'
import Button from 'react-bootstrap/Button';
import {LabelText} from '../../Language';
import './index.css';

export function SubmitSelectionFooter(props) {
    return (
        <div className="submit-selection-footer-main"> 
           { props.showSelectionFooter ? <>
                    <div className="footer-row footer-top-row">
                        <div className="submit-selection-left submit-selection-top-left"><span><LabelText tid={"no_of_records_selected"} /></span></div>
                        <div className="submit-selection submit-selection-count">{props.selectedCount}</div>
                        <div className="submit-selection">
                            <Button variant="primary"
                                size="sm"
                                className= {!props.isSubmitSelectionAllowed ? "submit-selection-btn disable-btn" : "submit-selection-btn submit-selection-btn-bgcolor"}
                                disabled={!props.isSubmitSelectionAllowed}
                                onClick={(ev)=>props.isSubmitSelectionAllowed ? props.submitSelectedHandler(props.selectedData, props.selectedDate)
                                            : ev.preventDefault()
                                        }
                            ><LabelText tid="submit_selection" /></Button>
                        </div>
                    </div>
            </> : <></> }
        </div>
    )
}